import "./PayoffMatrixGridComponent.scss";
import {IComponentOptions} from "angular";
import {PayoffMatrixGridData} from "../../models/PayoffMatrixGridData";

export const PayoffMatrixGrid = "tfPayoffMatrixGrid";

export function payoffMatrixGrid(): IComponentOptions {
    return {
        templateUrl: "app/components/charts/payoff/payoff-matrix/components/grid/PayoffMatrixGridComponent.html",
        bindings: {
            data: "<"
        },
        controllerAs: "ctrl",
        controller: PayoffMatrixGridComponentController
    };
}

export class PayoffMatrixGridComponentController {

    public data: PayoffMatrixGridData;

    /** @ngInject */
    public constructor() {

    }
}
